// extracted by mini-css-extract-plugin
export var closeButton = "_1i-3";
export var header = "_1i-0";
export var link = "_1i-1";
export var retryButton = "_1i-2";